import { Edit, SimpleForm, TextInput, required } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const SupplierEdit = () => (
  <Edit title="עריכת ספק">
    <SimpleForm>
      <Box sx={layout.formGrid}>
        <TextInput source="name"  label="שם הספק" fullWidth validate={required('שדה חובה')} />
        <TextInput source="phone" label="טלפון"    fullWidth />
        <TextInput source="email" label="אימייל"   fullWidth />
      </Box>
      <TextInput source="notes" label="הערות" multiline rows={3} fullWidth />
    </SimpleForm>
  </Edit>
);
export default SupplierEdit;
